// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SmartRocketIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M9.878 19.926a1 1 0 0 1-.633 1.265c-1.696.566-2.597 1.987-3.08 3.434a9.639 9.639 0 0 0-.377 1.587 9.636 9.636 0 0 0 1.587-.377c1.447-.483 2.868-1.384 3.434-3.08a1 1 0 1 1 1.897.632c-.849 2.547-2.963 3.767-4.698 4.345a11.796 11.796 0 0 1-3.233.58l-.089.002a1.01 1.01 0 0 1-.998-1.089 10.996 10.996 0 0 1 .072-.936c.072-.6.216-1.42.508-2.297.578-1.735 1.798-3.85 4.345-4.698a1 1 0 0 1 1.265.632Z"
					/>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M26.474 5.526c-1.148-.17-4.009-.233-6.938 2.696L11.758 16l4.243 4.243 6.346-6.347a.977.977 0 0 1 .034-.034l1.398-1.398c2.929-2.929 2.866-5.79 2.695-6.938Zm-9.388 16.46L22.07 17v5.657L18.028 26.7l-.942-4.714ZM9.85 16.92l5.228 5.228.988 4.943a2 2 0 0 0 3.376 1.022l4.042-4.043a2 2 0 0 0 .586-1.414V15l1.122-1.121c3.494-3.494 3.497-7.057 3.26-8.651a1.996 1.996 0 0 0-1.68-1.68c-1.595-.237-5.157-.234-8.651 3.26L17 7.928H9.343a2 2 0 0 0-1.414.587l-4.042 4.042a2 2 0 0 0 1.022 3.376l4.942.988Zm.164-2.006 4.986-4.986H9.344L5.3 13.972l4.714.943Z"
						clipRule="evenodd"
					/>
				</svg>
			}
		</IconContainer>
	);
}
